export const blockIconsCommunicationMarkEmailRead = (
	<span className='material-symbols-outlined'>mark_email_read</span>
);
